module.exports = __webpack_public_path__ + "static/media/logout.9568d5d6.svg";